export default __webpack_public_path__ + "static/media/loveseat-1-seat-2-back.f8a3fe7d.webp";